module.exports = __webpack_public_path__ + "media/vdrax_commercial.cdd0763b.mp4";